import FormItem from "@components/formItem";
import FloatingLabelInput from "@pages/profile-v2/pages/deposit/FloatingLabelInput";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import { Box, Content, ContentTitle } from "../baseItems";
import Base from "./base";

export default class PaparaFast extends Base {
	getStep1(translate) {
		const { stake, selectedCurrency } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<Fragment>
						<FormItem onRegister={() => this.registerField({ name: "account" })}>
							<Box>
								<FloatingLabelInput
									label={translate("PAPARA_NO")}
									name="account"
									type="text"
									onChange={this.onEnterValue.bind(this, "account")}
									placeholder="...................."
								/>
							</Box>
						</FormItem>
					</Fragment>
				</BoxWrapper>
			</Content>
		);
	}

	makeExternalPayment() {
		const { stake, account, selectedCurrency } = this.state;
		let withdrawData = {
			type: "HizliPapara",
			username: getUser().username,
			amount: {
				value: stake,
				currency: selectedCurrency ? selectedCurrency : "TRY",
			},
			papara_no: account,
			language: this.getActiveLanguageCode(),
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
